import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

export default function PCCom({ title, img, subtitle, desc, tips }: any) {
    return (
        <div className={`pc-com ${css['pc-com']}`}>
            <h2 className="dp3-title">{title}</h2>
            <div className="img-box">
                <EFPicture src={img} alt={title} />
            </div>
            <div className="info-box">
                <p className="subtitle">{subtitle}</p>
                <p className="desc">
                    {desc}
                    <span className="tips">{tips}</span>
                </p>
            </div>
        </div>
    );
}
